import React from 'react';
import SurveyMultiCard from './display-modes/SurveyMultiCard';
import SurveySingleCard from './display-modes/SurveySingleCard';

const surveyTypes = {
  SURVEY: 'survey',
  TABLET: 'tablet',
  AUDITION: 'audition',
};

export const questionTypes = {
  MULTI: 'multiselect',
  RADIO: 'radio',
  TEXT: 'text',
  NUMBER: 'number',
  RATING: 'rating',
  STAR_RATING: 'star_rating',
  EMPLOYEES: 'employees',
  SEQUENCE: 'sequence',
  FILE: 'file',
  EMOJI: 'emoji',
  SKILLS: 'skills',
  DROPDOWN: 'dropdown',
  SIGNATURE: 'handwrittenInput',
  GRID: 'grid',
  GRIDSPOT: 'gridspot',
  INVENTORY: 'inventory',
};

export default function SurveyPreviewBody({ step, brandDetails, survey, questions, recipient, surveyDisplayMode }) {
  return (
    <div
      style={{
        backgroundColor: brandDetails.secondaryColor,
        overflowY: 'auto',
        paddingBottom: '15px',
      }}
    >
      <div className="mx-auto question-container">
        {surveyDisplayMode === 'singlepage' ? (
          <SurveySingleCard
            step={step}
            survey={survey}
            questions={questions}
            recipient={recipient}
            questionTypes={questionTypes}
          />
        ) : (
          <SurveyMultiCard
            survey={survey}
            questions={questions}
            recipient={recipient}
            questionTypes={questionTypes}
            surveyTypes={surveyTypes}
          />
        )}
      </div>
    </div>
  );
}
